import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import LawyerCard from './lawyer-card'
import '../styles/lawyer.css'


function LawyerGrid() {
    const [lawyers, setLawyers] = useState([])

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/lawyers.txt`)
            .then(response => response.text())
            .then(text => {
                const lines = text.split('\n').filter(line => line.trim() !== '')
                const lawyersData = lines.map(line => {
                    const fields = line.split(';')
                    if (fields.length !== 7) return null
                    const [id, name, area, profile, image, email, phone] = fields
                    return {
                        id: id.trim(),
                        name: name.trim(),
                        area: area.trim(),
                        profile: `/img/abg/` + profile.trim(),
                        image: `${process.env.PUBLIC_URL}/img/abg/${image.trim()}`,
                        email: email.trim(),
                        phone: phone.trim()
                    }
                }).filter(lawyer => lawyer !== null)
                setLawyers(lawyersData)
            })
    }, [])

    return (
        <div className='container-lawyers'>
            <div className="container-xxl pt-2 pb-5 d-flex justify-content-center">
                <div className="row col-lg-12">
                    {lawyers.map((lawyer) => (
                        <div key={lawyer.id} className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center">
                            <NavLink
                                to={`/lawyer-profile/${lawyer.id}`}
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                <LawyerCard {...lawyer} />
                            </NavLink>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default LawyerGrid
